import { useMemo } from 'react';

import { useIntl } from 'ha/i18n';

import { buildParams } from '@ha/search-query';

export const useRoomPageLink = (
  listingPath: string,
  queryParams?: Record<string, unknown>,
) => {
  const { urlResolver } = useIntl();

  const roomLink = useMemo(() => {
    const roomUrl = listingPath;

    if (!listingPath) {
      return '';
    }

    return `${urlResolver.formatHrefURL(roomUrl)}${
      queryParams ? buildParams(queryParams) : ''
    }`;
  }, [urlResolver, listingPath, queryParams]);

  return roomLink;
};
